module.exports = __webpack_public_path__ + "img/map-image.ae70d075.png";